export let VisibilityType;(function(i){i["SURFACE"]="Foreground3D";i["TERRAIN"]="Terrain"})(VisibilityType||(VisibilityType={}));